import { render, staticRenderFns } from "./UserPermissionTree.vue?vue&type=template&id=3c4af127&scoped=true&"
import script from "./UserPermissionTree.vue?vue&type=script&lang=ts&"
export * from "./UserPermissionTree.vue?vue&type=script&lang=ts&"
import style0 from "./UserPermissionTree.vue?vue&type=style&index=0&id=3c4af127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4af127",
  null
  
)

export default component.exports